import React from 'react';
import { reduxForm, Field, getFormValues, isDirty } from 'redux-form';
import { connect } from 'react-redux';
import { MenuItem } from 'react-bootstrap';

import Dropdown from 'components/Dropdown';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import { ActionBarWrapper } from 'components/wrappers/pages';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import ButtonLoadingSpinner from 'components/ButtonLoadingSpinner';
import Tooltip from 'components/TooltipComponent';

import {
  onChangeOutletIds,
  exportRecipes,
  showCreateRecipesModal,
  onClickCreateRecipes,
  setFilterRecipes,
} from 'actions/ingredients/recipes';
import { askConfirmAction } from 'actions/confirm-action';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode } from 'utils/fullSite';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  static NAMESPACE_OPTIONS = [
    {
      id: 'recipes',
      name: 'recipes',
    },
  ];

  constructor(props) {
    super(props);
    this._tooltipWithDots = Tooltip({ totalStep: 4 });
  }

  render() {
    const {
      outlets,
      totalCount,
      createRecipesForm: { isLoading },
    } = this.props;

    return (
      <div>
        <MenuTitle menuTitle="Recipes" />
        <div
          className="col-sm-4 hidden-xs col-md-6 action-recipe"
          style={{ paddingRight: 0 }}
        >
          <span className={`${styles['pull-right']}`}>
            <button className="btn btn-default mr-10px">
              {' '}
              Total: {totalCount}{' '}
            </button>
            {!isFullSiteMode() && isLoading ? (
              <ButtonLoadingSpinner title="Importing" disabled />
            ) : (
              <Dropdown>
                <Dropdown.Toggle
                  bsStyle="primary"
                  title="Import / Export"
                ></Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem eventKey="1" onSelect={this._onClickImportButton}>
                    Import Recipes
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem eventKey="2" onSelect={this._onClickExport}>
                    Export Recipes
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            )}
            <button
              className="btn btn-primary ml-10px"
              onClick={this._onClickCreateRecipes}
            >
              Create Recipe
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className="col-sm-8 col-xs-12" style={{ paddingLeft: 0 }}>
            <form
              className={`form-inline ${styles['action-bar']}`}
              onSubmit={e => {
                e.preventDefault();
              }}
            >
              <div className="form-group mr-5px">
                <Field
                  name="outletIds"
                  component={DropdownOutlet}
                  outlets={outlets}
                  onChangeOutletIds={this._onChangeOutletIds}
                  allOutletOption={false}
                />
              </div>
              <div className="form-group mr-5px">
                <Field
                  name="search"
                  component={SearchBar}
                  placeholder="Search"
                  onChange={this._onChangeFilterKeyword}
                />
              </div>
            </form>
          </div>
        </ActionBarWrapper>
      </div>
    );
  }

  _onClickExport = () => {
    const { dispatch, search } = this.props;
    const prefix = 'Recipes - ';
    dispatch(
      exportRecipes(
        {
          keyword: search.search,
          outletName: search.outletName,
          email: search.email,
          export_task: 'list',
        },
        prefix,
        search.outletIds[0]
      )
    );
  };

  _onClickImportButton = () => {
    const { dispatch, search } = this.props;
    dispatch(showCreateRecipesModal(search.outletIds[0]));
  };

  _onClickCreateRecipes = () => {
    const { dispatch, search, isDirtyForm } = this.props;
    const { outletIds } = search;
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickCreateRecipes(outletIds[0])));
    } else {
      dispatch(onClickCreateRecipes(outletIds[0]));
    }
  };

  _onChangeFilterKeyword = (event, search) => {
    const { dispatch } = this.props;
    dispatch(setFilterRecipes(search));
  };

  _onChangeOutletIds = outletIds => {
    const { dispatch, isDirtyForm } = this.props;
    if (isDirtyForm) {
      dispatch(askConfirmAction(onChangeOutletIds(outletIds)));
    } else {
      dispatch(onChangeOutletIds(outletIds));
    }
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const {
    outlets,
    showImportModal,
    createRecipesForm,
    totalCount,
  } = state.ingredients.recipes;

  return {
    isDirtyForm: isDirty('recipes')(state),
    search: getFormValues('search')(state),
    email: state.moka.user.email,
    createRecipesForm,
    outlets,
    showImportModal,
    totalCount,
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ActionBar));
